import React, { Component } from 'react'
import DatePicker from 'react-datepicker';
import moment from "moment";
import 'react-datepicker/dist/react-datepicker.css';
import { Link } from 'react-router-dom'
import log from '../../../helpers/logger'
import { auth, getCurrentUser } from '../../../helpers/auth'
import { getTimeStamp, getUUIDV4 } from '../../../helpers/utils'
import {
  createFile_cover_url_list,
  updateFile_cover_url_list,
  getFile_cover_url_list,
  deleteFile_cover_url_list } from '../../../services/File_cover_url_listService'

function setErrorMsg(error) {
  return {
    errorMsg: error.message
  }
}

export default class File_cover_url_listPageEdit extends Component {

  constructor(props) {
    super(props);
    this.state = {
      
      file_url: '', 
      filename: '', 
      issue_id: '', 
      date_created: '', 

      errorMsg: null,
      currentUser: null,
      isLoading: true
    };

    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

  }

  componentWillMount() {
    log.debug('componentWillMount')
  }
  async componentDidMount(){
    log.debug('componentDidMount')
    let user = await getCurrentUser();
    this.setState({currentUser: user})

    // load info
    let file_cover_url_list = await getFile_cover_url_list(this.props.match.params.id)
    log.debug(file_cover_url_list)

    this.setState({file_cover_url_listId: this.props.match.params.id})
    this.setState({
      
      file_url: file_cover_url_list.file_url === undefined ? '' : file_cover_url_list.file_url, 
      filename: file_cover_url_list.filename === undefined ? '' : file_cover_url_list.filename, 
      issue_id: file_cover_url_list.issue_id === undefined ? '' : file_cover_url_list.issue_id, 
      date_created: file_cover_url_list.date_created === undefined ? '' : file_cover_url_list.date_created, 

      })
    // setup for moment DatePicker
    //this.setState({date_created: moment(file_cover_url_list.date_created)})

    log.debug(this.state)

    log.debug('all data is loaded.')
    this.setState({isLoading: false})
  }

  handleDateChange(date) {
    this.setState({
      date_created: date
    });
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    // bind all input to setState
    this.setState({
      [name]: value
    });
    log.debug(this.state)

  }

  async handleSubmit(event) {
    event.preventDefault();

    log.debug(this.state.date_created.toDate())

    // if you hace date.
    //date_created: this.state.date_created.toDate(),

    let file_cover_url_list = {
      
      file_url: this.state.file_url , 
      filename: this.state.filename , 
      issue_id: this.state.issue_id , 
      date_created: this.state.date_created , 
    }
    log.debug(file_cover_url_list)

    try{
      let result = await updateFile_cover_url_list(this.state.file_cover_url_listId, file_cover_url_list)
      log.debug('update success')
      //redirect to view
      this.props.history.push(`/file_cover_url_list/view/${this.state.file_cover_url_listId}`)
    }catch (err) {
      log.debug(err)
      this.setState(setErrorMsg(err))
    }

  }

  render () {

    let content;

    if (this.state.isLoading) {
      content = <div>Loading...</div>;
    } else {
      content =
      <div>
        <h4 className="page-header">
          <Link to='/file_cover_url_list'>File_cover_url_list</Link> -> &nbsp;
          <Link to={`/file_cover_url_list/view/${this.state.file_cover_url_listId}`}>{this.state.title}</Link>  ->&nbsp;
          Edit
        </h4>
        <form className="form-horizontal" role="form" onSubmit={this.handleSubmit}>

          {
            this.state.registerError &&
          <div className="form-group">
            <div className="col-sm-offset-2 col-sm-10">
              <div className="alert alert-danger" role="alert">
              <span className="sr-only">Error:</span>
              &nbsp;{this.state.registerError}
              </div>
            </div>
          </div>
          }

          
          <div className="form-group">
            <label htmlFor="file_url" className="col-sm-2 control-label">file_url:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="file_url"
                value={this.state.file_url}
                onChange={this.handleInputChange}
                placeholder="file_url"/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="filename" className="col-sm-2 control-label">filename:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="filename"
                value={this.state.filename}
                onChange={this.handleInputChange}
                placeholder="filename"/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="issue_id" className="col-sm-2 control-label">issue_id:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="issue_id"
                value={this.state.issue_id}
                onChange={this.handleInputChange}
                placeholder="issue_id"/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="date_created" className="col-sm-2 control-label">date_created:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="date_created"
                value={this.state.date_created}
                onChange={this.handleInputChange}
                placeholder="date_created"/>
            </div>
          </div>

          {/* <div className="form-group">
            <label htmlFor="date_created" className="col-sm-2 control-label">date_created:</label>
            <div className="col-sm-4">
              <DatePicker
                className="form-control"
                type="text"
                name="date_created"
                selected={this.state.date_created}
                onChange={this.handleDateChange}
                // showTimeSelect
                dateFormat="DD/MM/YYYY h:mm"
              />
            </div>
          </div> */}

          <div className="form-group">
            <div className="col-sm-offset-2 col-sm-10">
              <button type="submit" className="btn btn-primary">Edit</button>
            </div>
          </div>

        </form>
      </div>
    }


    return (
      <div>
          {content}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/File_cover_url_listPage/File_cover_url_listPageEdit.js